import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-83" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-84" data-mp="1ge0fontl8wdl">
        <div className="text-center" data-id="element-85" data-mp="1gauuhjo2yen5">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-86" data-mp="2e0pn5d72816u">
            Gut zu wissen
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-87" data-mp="2924o3h3jnnjz">
            Häufig gestellte Fragen
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-88" data-mp="1z2nj71w49dp2">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl bg-white" data-id="element-89" data-mp="noa3wlffi6kn" data-mpi={index}>
                <h3 data-id="element-90" data-mp="phy23m8hy5uy">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" data-id="element-91" data-mp="phek65iujhgx">
                    <span className="text-sm font-bold text-ink" data-id="element-92" data-mp="kkxuh6w00v1q">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-93" data-mp="6pvjw6g7ihil" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-94" data-mp="1q0qnw8ylfud">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-95" data-mp="3jyrs0nvr8sd7">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-ink/60" data-id="element-96" data-mp="1kq9no7svb574">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}